export const CollectionListTranslations = {
    collectionListTranslations: {
        pageTitle: 'Collections',
        description: 'Browse our collections of expert articles, webinars and more.',
    }
}